/* eslint-disable import/no-unresolved */
/** @import { FC } from 'react' */
import { Icon } from '@plone/volto/components';
import pinnenSVG from '../../../icons/pinnen.svg';
import { hasRole } from '../../../helpers/Users';
import React, { useEffect, useState } from 'react';
//noinspection ES6CheckImport
import { getVocabulary, updateContent } from '@plone/volto/actions';
import { useDispatch, useSelector } from 'react-redux';
import { flattenToAppURL } from '@plone/volto/helpers';

const defaultLocations = [];

const PinContent = (user) => {
  const allowedRoles = ['Manager', 'Site Administrator'];
  const dispatch = useDispatch();
  const content = useSelector((state) => state?.content);
  const locations = useSelector(
    (state) =>
      state.vocabularies?.[
        'hornundhorn.contenttypes.vocabularies.metadata_location'
      ]?.items || defaultLocations,
  );
  const [, toggleUpdateLocationsForm] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  const toggleSelectedOptions = (item) => {
    const index = selectedOptions.indexOf(item.label);

    if (index === -1) {
      setSelectedOptions([...selectedOptions, item.label]);
    } else {
      setSelectedOptions(selectedOptions.filter((option, i) => i !== index));
    }
  };
  const open = (e) => {
    toggleUpdateLocationsForm(
      e.target.parentElement.classList.toggle('hide-form'),
    );
  };
  const save = () => {
    dispatch(
      updateContent(flattenToAppURL(content.data['@id']), {
        location: selectedOptions,
      }),
    );
    //noinspection JSUnresolvedFunction
    window.location.reload(false);
  };
  const abort = (e) => {
    toggleUpdateLocationsForm(
      e.target.parentElement.parentElement.classList.toggle('hide-form'),
    );
    setSelectedOptions(
      [...content.data.location].map((location) => location.title),
    );
  };
  const isSelected = (item) => {
    return selectedOptions.includes(item.label);
  };

  useEffect(() => {
    dispatch(
      getVocabulary({
        vocabNameOrURL:
          'hornundhorn.contenttypes.vocabularies.metadata_location',
        size: 1000,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (content?.data?.location) {
      setSelectedOptions(
        [...content.data.location].map((location) => location.title),
      );
    }
  }, [content?.data]);

  if (hasRole(user.user, allowedRoles)) {
    return (
      <>
        <div className={'update-locations-wrapper'}>
          <Icon
            className={'update-location-open-form-button'}
            title="Standorte setzen"
            data-active={selectedOptions.length > 0}
            name={pinnenSVG}
            size="1.25em"
            onClick={(e) => open(e)}
          />
          <form className={'update-locations-form'}>
            <div className={`filterdialog`}>
              {locations.map((item, idx) => (
                <label className={'filteritem'} key={idx}>
                  <input
                    aria-checked={isSelected(item)}
                    type="checkbox"
                    checked={isSelected(item)}
                    disabled={content?.data.review_state === 'verified'}
                    value={item.value}
                    id={item.value}
                    name={item.value}
                    onChange={() => toggleSelectedOptions(item)}
                    aria-label={item.label}
                  />
                  <span
                    className={`checkbox`}
                    aria-checked={isSelected(item)}
                  />
                  {item.label}
                </label>
              ))}
            </div>
            {content?.data.review_state !== 'verified' && (
              <button
                type="button"
                className={'huh primary update-locations-button'}
                title="Standorte speichern"
                onClick={() => save()}
              >
                Speichern
              </button>
            )}
            <button
              type="button"
              className={'huh'}
              title="Auswahl abbrechen"
              onClick={(e) => abort(e)}
            >
              Abbrechen
            </button>
          </form>
        </div>
      </>
    );
  }
  return <div></div>;
};

export default PinContent;
